export default function Button(props) {

  const {children, type= "button", className = "", ...otherProps} = props;

  return (
    <button className={"basic-btn " + className} type={type} {...otherProps}>
      {children}
    </button>
  )
}